import { render, staticRenderFns } from "./employee-records.vue?vue&type=template&id=490b9dfd&"
import script from "./employee-records.vue?vue&type=script&lang=js&"
export * from "./employee-records.vue?vue&type=script&lang=js&"
import style0 from "./employee-records.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "employee-records.vue"
export default component.exports